<template>
  <b-row>
    <b-col md="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-card>
          <div slot="header" v-if="display_entity">
            Modification d'un <strong>utilisateur</strong>  
          </div>
          <div slot="header" v-if="!display_entity">
            Modification d'un administrateur <strong>{{ entite_name }}</strong>  
          </div>
          <b-row class="form-group">
            <b-col md="6">
              <label for="device">Nom</label>
              <b-form-input type="text" v-model="user.name" placeholder="Nom complet de l'agent"></b-form-input>
            </b-col>
            <b-col md="6">
              <label for="role">Role</label>
              <!-- <b-form-select id="role" :plain="true" :options="options_roles" v-model="user.roles" :disabled="grise_element == true">
              </b-form-select> -->
              <el-select v-model="value2" filterable multiple placeholder="Selectionnez les différents roles" style="width:100%;" :disabled="grise_element == true">
                <el-option
                  v-for="item in options_roles"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="6">
              <label for="solde">Email</label>
              <b-form-input type="email" v-model="user.email" placeholder="Email de l'utilisateur"></b-form-input>
            </b-col>    
            <b-col md="6" >
              <label for="entite_id">Entite</label>
              <b-form-select id="entite_id" :plain="true" :options="options" v-model="user.entite_id" disabled>
              </b-form-select>
            </b-col>
          </b-row>
         
          <!-- <b-row class="form-group">
            <b-col md="12" >
              <label for="entite_id">Entite</label>
              <b-form-select id="entite_id" :plain="true" :options="options" v-model="user.entite_id">
              </b-form-select>
            </b-col>
          </b-row> -->
          <div slot="footer">
            <span v-if="can('user-edit')"><b-button type="submit" size="sm" variant="primary" @click.prevent="put()"><i class="fa fa-dot-circle-o"></i> Modifier</b-button></span>
            <b-button type="reset" @click="goBack" size="sm" variant="danger"><i class="fa fa-ban"></i> Annuler </b-button>
          </div>
        </b-card>    
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: 'tables',
  data(){
    return {
      userConnected:{},
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      display_entity :false,
      options : [],
      options_roles : [],
      user:{
            id:'',
            name: '',
            email: '',
            roles:[],
            _method:'PUT'
      },
      entities:[],
      value1: [],
      value2: [],
      entite_name :'',
      grise_element:false
    }
  },
  methods:{
    countDownChanged (dismissCountDown) {
        this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    can(perm){
        return store.getters['auth/can'](perm)
    },
    async put(){    
        this.user.roles = this.value2 
        this.response = await this.$store.dispatch('user/put_users',{id:this.user.id,user:this.user})
        this.showAlert() 
        
    },
    async display_users(){
        let response = await this.$store.dispatch('user/show_users',this.$route.params.id)
        console.log("user identit ",response.roles[0].name)
        //this.user.roles = response.roles[0].name
        response.roles.forEach((element)=>{
          console.log(element)
          this.value2.push(element.name)
        })
        this.user.email = response.email
        this.user.entite_id = response.entite_id
        this.user.name = response.name
        this.user.id = response.id
        
   },
    async get_all_entities(){
      
      if(this.user.entite_id === null || this.user.entite_id === 'null'){
          this.display_entity = true
          this.userConnected = await store.getters['auth/get_user']
          
          if (this.userConnected.role.toUpperCase() == 'SUPER ADMIN'){
              let serverParams= {
                page:1,
                current_page: 1,
                paginate: 10
              }
              await this.$store.dispatch('entity/get_all_entities',serverParams).then(()=>{
                return this.entities = store.getters['entity/rows'];    
              })
            }else{
              let serverParams= {
                page:1,
                current_page: 1,
                paginate: 10
              }
              await this.$store.dispatch('entity/get_all_authentites',serverParams).then(()=>{
                return this.entities = store.getters['entity/rows'];    
              })
            }
          //this.entities =  store.getters['entity/rows'];
          this.entities.forEach((element)=>{
              this.options.push({
                value:element.id,
                text:element.nom_commercial.toUpperCase(),
              })
              
          })
            
            if(this.options.length==1){
                this.user.entite_id = this.options[0].value
            }
      }else{         
          this.display_entity = false
          //this.user.entite_id = this.$route.params.entite_id
          console.log("entite idS ",this.user.entite_id)
          await this.$store.dispatch('entity/show_entites',this.user.entite_id).then((res)=>{
            console.log("my entity ",res)
            return this.entite_name = res.nom_commercial
          })
          this.options.push({
            value:this.user.entite_id,
            text:this.entite_name
          })
      }
    },
    
    async get_all_roles(){
      //recuration de l'entité selectionné
      //this.value2.push(this.user.roles)
      await this.$store.dispatch('entity/show_entites',this.user.entite_id).then((res)=>{
        return this.param_role = res.id
      })
      await this.$store.dispatch('role/get_roles_by_role',{role:this.user.roles,user_id:this.user.id}).then(()=>{
        store.getters['role/rows'].forEach(element => {
          this.options_roles.push({
            value:element.name,
            text:element.name.toUpperCase()
          })
        });
      }) 
      // if(this.options_roles.length==1){
      //     console.log('taille :',this.user.roles) 
      //     this.user.roles = this.options_roles[0].value
      //     this.grise_element = true
      // }
    },
    async get_user(){
        this.userConnected = await store.getters['auth/get_user']
        return this.userConnected 
    },
    
    reset(){
      this.user.name= '',
      this.user.roles= '',
      this.user.email= '',
      this.user.password= '' 
    },
    goBack() {
      this.$router.go(-1)
    },
  },
  async mounted(){
    await this.display_users()
    this.get_user()
    this.get_all_entities()
    this.get_all_roles()
  }
}
</script>
